export default {
  id: null,
  empresaID: null,
  pedido: null,
  obraRHID: null,
  responsavelID: null,
  situacao: null,
  secaoRHID: null,
  inicioObra: null,
  terminoObra: null,
  clienteRHID: null,
  equipe: null,
  cidadeID: null,
  status: null,
  observacao: null
}



// WEBPACK FOOTER //
// ./src/shared/models/business/employeeboardmodel.js